import { render, staticRenderFns } from "./transfer-order-modal.vue?vue&type=template&id=61c22615&scoped=true&"
import script from "./transfer-order-modal.component.ts?vue&type=script&lang=ts&"
export * from "./transfer-order-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./transfer-order-modal.scss?vue&type=style&index=0&id=61c22615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c22615",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c22615')) {
      api.createRecord('61c22615', component.options)
    } else {
      api.reload('61c22615', component.options)
    }
    module.hot.accept("./transfer-order-modal.vue?vue&type=template&id=61c22615&scoped=true&", function () {
      api.rerender('61c22615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/transfer-order-modal/transfer-order-modal.vue"
export default component.exports